// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__1JVSe","label":"Completed_label__1KTgM"};